const stepScaleImage = (img, step) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const targetCanvasSize = 700;
  const displayScale = 0.5;
  const reductionStep = step > 0 && step < 1 ? step : 0.5;

  canvas.width = 700;
  canvas.height = 700;
  ctx.fillStyle = 'transparent';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  const vRatio = canvas.width / img.width;
  const hRatio = canvas.height / img.height;
  const ratio = Math.min(vRatio, hRatio);

  const widthRatio = img.width * ratio * displayScale;
  const heightRatio = img.height * ratio * displayScale;

  const xShift = (canvas.width - widthRatio) / 2;
  const yShift = (canvas.height - heightRatio) / 2;

  if (Math.max(img.width, img.height) * reductionStep > targetCanvasSize) {
    let sourceCanvas = document.createElement('canvas');
    const sourceCtx = sourceCanvas.getContext('2d');

    let cur = {
      width: Math.floor(img.width * reductionStep),
      height: Math.floor(img.height * reductionStep),
    };

    sourceCanvas.width = cur.width;
    sourceCanvas.height = cur.height;
    sourceCtx.drawImage(img, 0, 0, cur.width, cur.height);

    while (Math.max(cur.width, cur.height) * reductionStep > targetCanvasSize) {
      const next = {
        width: Math.floor(cur.width * reductionStep),
        height: Math.floor(cur.height * reductionStep),
      };

      const nextCanvas = document.createElement('canvas');
      nextCanvas.width = next.width;
      nextCanvas.height = next.height;
      const nextCtx = nextCanvas.getContext('2d');
      nextCtx.drawImage(sourceCanvas, 0, 0, cur.width, cur.height, 0, 0, next.width, next.height);

      sourceCanvas = nextCanvas;
      cur = next;
    }

    ctx.drawImage(
      sourceCanvas,
      0,
      0,
      cur.width,
      cur.height,
      xShift,
      yShift,
      widthRatio,
      heightRatio,
    );
  } else {
    ctx.drawImage(img, 0, 0, img.width, img.height, xShift, yShift, widthRatio, heightRatio);
  }

  return canvas.toDataURL('image/png');
};

export default stepScaleImage;
